import { Layout } from 'antd';
import styled from 'styled-components';
import Media from './utils/media';

export const LayoutStyled = styled(Layout)<{ lang?: string }>`
  height: 100vh;
  width: 100vw;
  font-family: ${(props) => (props.lang === 'zh' ? 'Roboto' : 'Inter')};
  overflow-y: auto;
  /* background-color: #d9d9d9; */
`;

export const WrapperStyled = styled.div`
  height: max-content;
  width: 100%;
  max-width: 1440px;
  margin: 0px auto;
  background-color: #ffffff;

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.MD';

    max-width: unset;
    width: 100%;
  }

  ${Media.lessThan(Media.SIZE.SM)} {
    content: 'Media.SIZE.SM';

    max-width: unset;
    width: 100%;
  }

  ${Media.lessThan(Media.SIZE.XS)} {
    content: 'Media.SIZE.XS';

    max-width: unset;
    width: 100%;
  }
`;
